import config from "../Config";
import { getCookieToken, isJwtExpired, clearTokenSession } from "./authSession";
import { dedupedFetch } from "./dedupedFetch";
import {
  emailFromCookieToken,
  isRestrictedResponse,
  redirectToNotAuthorized,
} from "./restrictedAccess";

function isProtectedAppApiUrl(url) {
  const u = String(url);
  if (config.AUTH_API && u.startsWith(config.AUTH_API)) return true;
  if (config.RUNNER_API && u.startsWith(config.RUNNER_API)) return true;
  if (config.MASTER_API && u.startsWith(config.MASTER_API)) return true;
  return false;
}

/**
 * For calls to AUTH_API / RUNNER_API: attaches the Cognito access token as Bearer.
 * If the token is expired, returns a 401 synthetic response.
 */
export async function authFetch(input, init = {}) {
  const url = typeof input === "string" ? input : input?.url ?? "";

  if (!isProtectedAppApiUrl(url)) {
    return dedupedFetch(input, init);
  }

  const token = getCookieToken();
  if (!token || isJwtExpired(token)) {
    clearTokenSession();
    return new Response(JSON.stringify({ detail: "Unauthorized" }), {
      status: 401,
      headers: { "Content-Type": "application/json" },
    });
  }

  const headers = new Headers(init.headers || {});
  headers.set("Authorization", `Bearer ${token}`);

  const response = await dedupedFetch(input, { ...init, headers });

  // Catches a session that was already open when the environment allowlist started
  // rejecting it — otherwise every page would just render its own 403 error.
  if (await isRestrictedResponse(response)) {
    redirectToNotAuthorized(emailFromCookieToken());
  }

  return response;
}
